export function request(url, { method, headers, body }) {
  const xhr = new XMLHttpRequest();

  xhr.open(method, url);

  xhr.withCredentials = true;

  Object.entries(headers).forEach(([name, value]) =>
    xhr.setRequestHeader(name, value)
  );

  return new Promise((resolve, reject) => {
    xhr.send(body);

    xhr.onerror = () => {
      reject(Error("Error uploading file"));
      //   console.error(xhr.response);
    };

    xhr.onload = () => {
      let response;

      try {
        response = JSON.parse(xhr.response);
      } catch (err) {
        reject(err);
      }

      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(response);
      } else {
        reject(response);
      }
    };
  });
}

export default request;
